import { render, staticRenderFns } from "./OutputConfiguration.vue?vue&type=template&id=47b27e16&"
import script from "./OutputConfiguration.vue?vue&type=script&lang=ts&"
export * from "./OutputConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports